import React, {useEffect} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import {fetchUnidade} from '../../../../store/empresa';
import EmpresaUnidadeCreatePage from './_create';
import EmpresaUnidadeDetailPage from './_detail';
import EmpresaUnidadeEditPage from './_edit';

export default function EmpresaUnidadePage() {
  const dispatch = useDispatchWithResult();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;

  useEffect(() => {
    dispatch(fetchUnidade({empresaId, id}));
  }, [empresaId, id]);

  return (
      <Switch>
        <Route path="/*/empresas/:empresaId/unidades/:id/edit" component={EmpresaUnidadeEditPage} />
        <Route path="/*/empresas/:empresaId/unidades/create" component={EmpresaUnidadeCreatePage} />
        <Route path="/*/empresas/:empresaId/unidades/:id" component={EmpresaUnidadeDetailPage} />
      </Switch>);
}
